import React from "react";

const COMPACT_BREAKPOINT = 1200;

/**
 * Hook der erkennt ob die aktuelle Viewport-Breite unter dem Compact-Breakpoint liegt.
 * Wird fuer responsive Tabellen verwendet, die auf kleineren Screens (z.B. iPad)
 * eine kompakte Text-Ansicht statt editierbarer Felder zeigen.
 */
const useIsCompactView = (): boolean => {
    const [isCompact, setIsCompact] = React.useState(
        typeof window !== "undefined" ? window.innerWidth < COMPACT_BREAKPOINT : false
    );

    React.useEffect(() => {
        const handleResize = () => {
            setIsCompact(window.innerWidth < COMPACT_BREAKPOINT);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isCompact;
};

export default useIsCompactView;
